import { render, staticRenderFns } from "./WarningIcon.vue?vue&type=template&id=458401a7&scoped=true&"
import script from "./WarningIcon.vue?vue&type=script&lang=ts&"
export * from "./WarningIcon.vue?vue&type=script&lang=ts&"
import style0 from "./WarningIcon.vue?vue&type=style&index=0&id=458401a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458401a7",
  null
  
)

export default component.exports